import React from 'react'
import styled from 'styled-components'

import Select from 'live/components/forms/ui/select'
import i18n from 'live/services/i18n'
import FilterDropdown from 'live/components/forms/ui/filter-dropdown'

interface FilterProps {
    currentFilter: CollectionFilterEnum
    onChangeFilter: (newValue: CollectionFilterEnum) => void
    hideDefaultIndex: boolean
    onChangeHideDefaultIndex: () => void
}

export enum CollectionFilterEnum {
    all = 'all',
    withCustom = 'withCustom',
    withoutTimestamp = 'withoutTimestamp'
}

type Filter = {
    value: CollectionFilterEnum
    label: string
}

const CollectionsFilter = ({
    currentFilter,
    onChangeFilter,
    hideDefaultIndex,
    onChangeHideDefaultIndex
}: FilterProps): React.ReactElement => {
    const options: Filter[] = [
        {
            value: CollectionFilterEnum.all,
            label: i18n('All indexes')
        },
        {
            value: CollectionFilterEnum.withCustom,
            label: i18n('Custom indexes')
        },
        {
            value: CollectionFilterEnum.withoutTimestamp,
            label: i18n('Missing timestamp index')
        }
    ]

    const getFilter = (value: CollectionFilterEnum): Filter => {
        const [selected] = options.filter(ops => ops.value === value)

        return selected
    }

    const setFilter = (value: CollectionFilterEnum): void => {
        const selected = getFilter(value)

        onChangeFilter(selected.value)
    }

    return (
        <FilterDropdown>
            <li className="menu-item">
                <div className="live-select form-group">
                    <label>{i18n('Index')}</label>
                    <Select
                        placeholder={i18n('Index')}
                        options={options}
                        value={getFilter(currentFilter)}
                        onChange={setFilter}
                        clearable={false}
                        searchable={false}
                        disabled={false}
                        formEnabledContext={false}
                    />
                </div>
            </li>
            <li className="menu-item">
                <CheckoutContainer>
                    <input
                        type="checkbox"
                        name="hideTrivial"
                        checked={hideDefaultIndex}
                        onClick={onChangeHideDefaultIndex}
                    />
                    <span>{i18n('Hide default indexes')}</span>
                </CheckoutContainer>
            </li>
        </FilterDropdown>
    )
}

export default CollectionsFilter

const CheckoutContainer = styled.label`
    display: flex !important;
    align-items: center;

    span {
        margin-left: 10px;
    }
`
